export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden"
      style={{ scrollMarginTop: '64px' }}
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20evening%20living%20room%20scene%20with%20soft%20blanket%20on%20sofa%2C%20warm%20amber%20glow%20from%20table%20lamp%2C%20abstract%20cinematic%20atmosphere%2C%20soft%20bokeh%20lights%2C%20comfortable%20home%20theater%20vibe%2C%20artistic%20minimal%20illustration%20style%2C%20gentle%20gradients%2C%20no%20people%2C%20warm%20terracotta%20and%20golden%20tones&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="被窝网电影 — 温暖追剧氛围"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/85 text-background-50 text-xs font-medium mb-4">
              每日更新 · 免费追剧
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl text-background-50 leading-tight mb-3">
              被窝网电影
              <br className="sm:hidden" />
              <span className="text-primary-300"> — 电视剧全集免费高清在线观看</span>
            </h1>

            <p className="text-lg md:text-xl text-background-200/90 font-light mb-2">
              最新热播剧免费追，无需充值尽享全集
            </p>

            <p className="text-sm md:text-base text-background-300/80 max-w-xl mx-auto lg:mx-0 leading-relaxed mb-6">
              被窝网电影聚合全网热门电视剧资源，涵盖国产剧、韩剧、美剧、日剧、泰剧等全品类正版片源，支持高清画质流畅播放不缓冲。每日更新最新剧集，追剧不等待，在被窝里就能畅享全集观影体验。当前热播推荐涵盖都市情感、古装传奇、悬疑探案等多种题材。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2 text-background-200/80">
                <span className="font-heading text-2xl text-primary-300">3000+</span>
                <span className="text-xs">部热播剧集</span>
              </div>
              <div className="w-px h-5 bg-background-300/30 hidden sm:block"></div>
              <div className="flex items-center gap-2 text-background-200/80">
                <span className="font-heading text-2xl text-accent-300">每日更新</span>
                <span className="text-xs">最新剧集</span>
              </div>
              <div className="w-px h-5 bg-background-300/30 hidden sm:block"></div>
              <div className="flex items-center gap-2 text-background-200/80">
                <span className="font-heading text-2xl text-secondary-300">全高清</span>
                <span className="text-xs">流畅不缓冲</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热播榜单
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full bg-background-50/15 text-background-50 border border-background-200/30 font-medium text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                浏览剧集索引
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[420px] lg:max-w-[460px]">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20a%20cozy%20bedroom%20at%20night%20with%20warm%20glowing%20tablet%20screen%20showing%20abstract%20cinematic%20visuals%2C%20soft%20blankets%2C%20warm%20amber%20and%20golden%20lighting%2C%20comfortable%20home%20entertainment%20atmosphere%2C%20minimal%20illustration%20style%2C%20warm%20terracotta%20and%20cream%20color%20palette%2C%20cozy%20evening%20vibe%2C%20no%20text&width=920&height=1200&seq=hero-visual-2026&orientation=portrait"
                alt="被窝网电影主视觉 — 温暖追剧体验"
                className="w-full h-auto"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}